import config from '../config';
import { request } from '../utils/request';

const accountDomain = `${config.host}${config.apiRouter.account}`;
const rioAccountDomain = `${config.host}${config.apiRouter.rioAccount}`;

const api = {
  // GetLoginUserInfo
  get_user_info (type) {
    return request({
      url: `${accountDomain}/GetLoginUserInfo`,
      headers: {
        'X-Requested-With': type === undefined && 'XMLHttpRequest',
      },
    });
  },

  // GetVendor
  get_vendor (data) {
    return request.post(`${accountDomain}/GetVendor`, data || {});
  },

  // GetVendorList
  get_vendor_list (data) {
    return request.post(`${accountDomain}/GetVendorList`, data || {});
  },

  // GetVendorDetailList（包含gitlab相关信息）
  get_vendor_detail_list (data) {
    return request.post(`${accountDomain}/GetVendorDetailList`, data || {});
  },

  // GetAgency
  get_agency (data) {
    return request.post(`${accountDomain}/GetAgency`, data || {});
  },

  // GetAgencyList
  get_agency_list (data) {
    return request.post(`${accountDomain}/GetAgencyList`, data || {});
  },

  // BindVendorAndGitlab
  bind_vendor_and_gitlab (data) {
    return request.post(`${accountDomain}/BindVendorAndGitlab`, data || {});
  },

  // RegisterAndBindGitlab
  register_and_bind_gitlab (data) {
    return request.post(`${accountDomain}/RegisterAndBindGitlab`, data || {});
  },

  // GetUserProfileList
  get_user_profile_list (data) {
    return request.post(`${accountDomain}/GetUserProfileList`, data || {});
  },

  // GetVendorGitlab
  get_vendor_gitlab (data) {
    return request.post(`${accountDomain}/GetVendorGitlab`, data || {});
  },

  // 更新账户信息
  update_account (data) {
    return request.post(`${accountDomain}/UpdateAccount`, data || {});
  },

  // 创建机构用户
  create_agency_account (data) {
    return request.post(`${accountDomain}/CreateAgencyAccount`, data || {});
  },

  // 创建供应商用户
  create_vendor_account (data) {
    return request.post(`${accountDomain}/CreateVendorAccount`, data || {});
  },
  // 重置用戶密码
  reset_password (data) {
    return request.post(`${accountDomain}/ResetPassword`, data || {});
  },

  // GetAccount
  get_account (data) {
    return request.post(`${accountDomain}/GetAccount`, data || {});
  },

  // rio接口 获取账号列表
  getRioAccountList (data) {
    const {
      limit,
      offset,
      key,
    } = data;
    return request.get(`${rioAccountDomain}/list?version=2018-12-18&limit=${limit}&offset=${offset}&key=${key}`);
  },
};

export default api;
